import React from 'react';
import ReactPagination from 'react-js-pagination';
import ReactPaginate from "react-paginate";

class Pagination extends React.Component {
  // render() {
  //   return (
  //     <nav aria-label="Page navigation" className="nav-pagination">
  //       {this.props.itemsCountPerPage < this.props.totalItemsCount &&
  //       <ReactPagination
  //                        activePage={this.props.activePage}
  //                        itemClass={`page-item`}
  //                        linkClass={`page-link mr-1`}
  //                        linkClassLast={`page-link mr-1`}
  //                        itemsCountPerPage={this.props.itemsCountPerPage}
  //                        pageRangeDisplayed={12}
  //                        totalItemsCount={this.props.totalItemsCount}
  //                        hideFirstLastPages={true}
  //                        onChange={(e) => this.props.changeHandler(e)}/>
  //       }
  //     </nav>
  //   );
  // }
  render() {
    return (
        <nav aria-label="Page navigation" className="nav-pagination">
          {this.props.itemsCountPerPage < this.props.totalItemsCount &&
          <ReactPaginate
              previousLabel=" <"
              nextLabel=">"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link mr-1"
              pageCount={Math.ceil(this.props.totalItemsCount/this.props.itemsCountPerPage)}
              pageRangeDisplayed={4}
              marginPagesDisplayed={2}
              onPageChange={(e) => this.props.changeHandler(e.selected)}
              containerClassName="pagination justify-content-center"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
              // eslint-disable-next-line no-unused-vars
              hrefBuilder={(page, pageCount, selected) =>
                  page >= 1 && page <= pageCount ? `/page/${page}` : '#'
              }
              hrefAllControls
              forcePage={this.props.activePage}
          />
          }
        </nav>
    );
  }
}

export default Pagination;
